import { useMutation } from '@maui/react-query'
import { maApiFetch } from '../api/apis'

export const useUserPreferencesMutation = (options = {}) => {
  return useMutation({
    mutationFn: (payload) => {
      return maApiFetch(
        '/preferences', {
          method: 'PUT',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          as: 'text',
          body: JSON.stringify({
            user: {
              preferences: payload,
              skip_phone_validation: true
            },
          }),
        },
        false
      )
    },
    optimisticUpdateKey: ['userProfile'],
    optimisticUpdateFn: (oldProfile, newPreference) => {
      return {
        ...oldProfile,
        preferences: {
          ...oldProfile.preferences,
          ...newPreference
        }
      }
    },
    ...options
  })
}
